import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "HomePage",
    component: () => import("@/views/HomePage.vue"),
    meta: { requiresAuth: false }, // 明确设置不需要认证
  },
  {
    path: "/buy",
    name: "PayLicense",
    component: () => import("@/views/PayLicense/index.vue"),
    meta: { title: "开通会员" },
  },
  {
    path: "/user",
    name: "UserCenter",
    component: () => import("@/views/UserCenter/index.vue"),
    meta: { title: "用户中心", requireAuth: true },
  },
  {
    path: "/aigc",
    name: "aigcserver",
    component: () => import("@/views/aigc/index.vue"),
    meta: { title: "AIGC智能内容服务" },
  },
  {
    path: "/login",
    name: "LoginPage",
    component: () => import("@/views/LoginPage.vue"),
    meta: {
      title: "用户登录",
      showHeader: false,
      requiresAuth: false,
      isLoginPage: true,
    },
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: () => import("@/views/Register.vue"),
    meta: { title: "用户注册", showHeader: false },
  },
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/tech-docs",
    name: "TechDocs",
    // 使用一个简单的占位组件，实际内容由 App.vue 控制
    component: {
      render: (h) =>
        h("div", {
          style: { display: "none" },
        }),
    },
    meta: {
      title: "技术文档",
      showHeader: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 获取token
  const token = localStorage.getItem("user_token");
  const isAuthenticated = !!token;
  if (to.meta.title) {
    document.title = `${to.meta.title} - UTS数据科技`;
  }
  // 如果目标路由需要认证且用户未登录
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // 保存目标路由，登录后跳转
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      // 已登录，直接放行
      next();
    }
  }

  // 如果是登录页且用户已登录，重定向到首页
  else if (to.matched.some((record) => record.meta.isLoginPage)) {
    if (isAuthenticated) {
      // 如果有重定向参数，跳转到指定页面
      const redirect = from.query.redirect || to.query.redirect;
      if (redirect) {
        next(redirect);
      } else {
        next("/user/center");
      }
    } else {
      next();
    }
  }
  // 其他情况直接放行
  else {
    next();
  }
});
// 简化错误处理
router.onError((error) => {
  console.error("路由错误:", error);
  // 避免重复导航错误
  if (error.name === "NavigationDuplicated") {
    return;
  }
});

export default router;
